<template>
  <v-badge v-if="dotActive" :color="color" :dot="dot" :location="location" :content="content">
    <slot />
  </v-badge>
  <slot v-else />
</template>

<script setup lang="ts">
const {
  color = "error",
  dot = true,
  location = undefined,
  content = undefined,
} = defineProps<{
  dotActive: boolean
  location?: "top" | "bottom" | "left" | "right" | "top left" | "top right" | "bottom left" | "bottom right"
  color?: string
  dot?: boolean
  content?: number | string
}>()
</script>

<style scoped></style>
